/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { ReeseModelDto } from "../models/reese-model-dto";
import { ReeseConversationDto } from "../models/reese-conversation-dto";
import { ReeseMessageDto } from "../models/reese-message-dto";
import { ReeseChatRequest } from "../models/reese-chat-request";
@Injectable({
  providedIn: "root",
})
class ReeseChatService extends __BaseService {
  static readonly reeseChatGetModelsPath = "/api/ReeseChat/Models";
  static readonly reeseChatGetConversationsPath =
    "/api/ReeseChat/Conversations";
  static readonly reeseChatGetMessagesPath =
    "/api/ReeseChat/Conversations/{threadId}/Messages";
  static readonly reeseChatDeleteConversationPath =
    "/api/ReeseChat/Conversations/{threadId}";
  static readonly reeseChatChatPath = "/api/ReeseChat/Chat";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  reeseChatGetModelsResponse(): __Observable<
    __StrictHttpResponse<Array<ReeseModelDto>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReeseChat/Models`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReeseModelDto>>;
      })
    );
  }
  reeseChatGetModels(): __Observable<Array<ReeseModelDto>> {
    return this.reeseChatGetModelsResponse().pipe(
      __map((_r) => _r.body as Array<ReeseModelDto>)
    );
  }
  reeseChatGetConversationsResponse(): __Observable<
    __StrictHttpResponse<Array<ReeseConversationDto>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReeseChat/Conversations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReeseConversationDto>>;
      })
    );
  }
  reeseChatGetConversations(): __Observable<Array<ReeseConversationDto>> {
    return this.reeseChatGetConversationsResponse().pipe(
      __map((_r) => _r.body as Array<ReeseConversationDto>)
    );
  }

  /**
   * @param threadId undefined
   */
  reeseChatGetMessagesResponse(
    threadId: string
  ): __Observable<__StrictHttpResponse<Array<ReeseMessageDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReeseChat/Conversations/${threadId}/Messages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReeseMessageDto>>;
      })
    );
  }
  /**
   * @param threadId undefined
   */
  reeseChatGetMessages(threadId: string): __Observable<Array<ReeseMessageDto>> {
    return this.reeseChatGetMessagesResponse(threadId).pipe(
      __map((_r) => _r.body as Array<ReeseMessageDto>)
    );
  }

  /**
   * @param threadId undefined
   */
  reeseChatDeleteConversationResponse(
    threadId: string
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/ReeseChat/Conversations/${threadId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param threadId undefined
   */
  reeseChatDeleteConversation(threadId: string): __Observable<Blob> {
    return this.reeseChatDeleteConversationResponse(threadId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  reeseChatChatResponse(
    request: ReeseChatRequest
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReeseChat/Chat`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param request undefined
   */
  reeseChatChat(request: ReeseChatRequest): __Observable<null> {
    return this.reeseChatChatResponse(request).pipe(
      __map((_r) => _r.body as null)
    );
  }
}

module ReeseChatService {}

export { ReeseChatService };
